import styled from 'styled-components';
import { colors } from 'shared/theme';

export const Row = styled.div`
  font-family: 'Bebas Neue', sans-serif;
  font-size: 4.5rem;
  color: ${colors.darkTitle};
`;
